import { Select } from 'antd';
import { useId } from 'infrastructure/hooks/utils/useId';
import { useSelectAll } from 'infrastructure/antd/hooks/use-select-all';

import s from './styles.module.scss';

import type { SelectProps } from 'antd';
import type { DefaultOptionType } from 'antd/es/select';

export interface BaseSelectProps<Value extends DefaultOptionType = any>
  extends SelectProps<Value | Value[]> {
  options: Value[];
  label?: string;
  showSelectAll?: boolean;
  width?: string;
}

export interface Option<T = string> {
  label: string;
  value: T;
}

const BaseSelect = <T extends DefaultOptionType>({
  label,
  options,
  showSelectAll,
  value,
  onChange,
  width: maxWidth = '100%',
  allowClear = true,
  ...props
}: BaseSelectProps<T>) => {
  const id = props.id || useId('select_');

  const selectProps = useSelectAll({
    showSelectAll,
    value,
    onChange,
    options,
  });

  return (
    <div className={s.wrapper}>
      {label && (
        <label htmlFor={id} className={s.label}>
          {label}
        </label>
      )}
      <Select
        id={id}
        style={{ width: '100%', maxWidth }}
        labelInValue
        optionFilterProp="label"
        allowClear={allowClear}
        {...props}
        {...selectProps}
      />
    </div>
  );
};

export default BaseSelect;
